import { randomInt } from '#/utils/functional/number/randomInt';

export function rollABExperiment<TBucketId extends string>(
  allBuckets: { id: TBucketId; probability: number }[],
  overrideRandom?: number,
): TBucketId {
  // Make sure we never assign to a bucket with probability 0
  const buckets = allBuckets.filter((bucket) => bucket.probability > 0);

  const bucketAssignmentNumber =
    typeof overrideRandom === 'undefined' ? randomInt(99) : overrideRandom;

  let accumulatedProbability = 0;
  for (const bucket of buckets) {
    accumulatedProbability += bucket.probability * 100;

    if (bucketAssignmentNumber < accumulatedProbability) return bucket.id;
  }

  return buckets[0].id;
}
